import { People, Public } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { withForm } from "@/components/Forms";
import CustomCard from "../../CreateDeliveryDeal/ui/custom-card";
import { deliveryOptionFormOpts } from "../option.form.opts";
import { PartnerList } from "./PartnerSection";

const MODES = [
  {
    value: "GLOBAL",
    labelKey: "deliveryOption.visibility.global",
    descriptionKey: "deliveryOption.visibility.globalDescription",
    icon: <Public />,
    color: "primary.main",
  },
  {
    value: "PARTNER_LIST",
    labelKey: "deliveryOption.visibility.partnerList",
    descriptionKey: "deliveryOption.visibility.partnerListDescription",
    icon: <People />,
    color: "warning.main",
  },
] as const;

export const VisibilitySection = withForm({
  ...deliveryOptionFormOpts,
  render: ({ form }) => {
    const { t } = useTranslation();

    return (
      <CustomCard
        label={t("deliveryOption.visibility.title")}
        subtitle={t("deliveryOption.visibility.subtitle")}
      >
        {/* Mode selector */}
        <form.AppField name="visibilityMode">
          {(f) => (
            <Stack direction="row" spacing={2}>
              {MODES.map((mode) => {
                const selected = f.state.value === mode.value;
                return (
                  <Box
                    key={mode.value}
                    onClick={() => f.handleChange(mode.value)}
                    sx={{
                      flex: 1,
                      border: 2,
                      borderRadius: 2,
                      borderColor: selected ? mode.color : "grey.300",
                      p: 2,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      bgcolor: selected ? `${mode.color}10` : "transparent",
                      "&:hover": { borderColor: mode.color, bgcolor: `${mode.color}08` },
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="flex-start">
                      <Box
                        sx={{
                          color: selected ? mode.color : "text.disabled",
                          transition: "color 0.2s",
                          mt: 0.25,
                        }}
                      >
                        {mode.icon}
                      </Box>
                      <Box>
                        <Typography
                          variant="body1"
                          fontWeight={selected ? 700 : 500}
                          color={selected ? mode.color : "text.primary"}
                          mb={0.5}
                        >
                          {t(mode.labelKey)}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          {t(mode.descriptionKey)}
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                );
              })}
            </Stack>
          )}
        </form.AppField>

        {/* Partner list — only when PARTNER_LIST mode is active */}
        <PartnerList form={form} />
      </CustomCard>
    );
  },
});
